import { httpClient } from 'src/config/http';
import { NavigationService } from 'src/shared/services/NavigationService';
import { ToastNotificationsService } from 'src/shared/services/ToastNotificationsService';

import { ValidateTokenData } from '../models/auth';

export class TokenAuthenticator {
    constructor(
        private toastNotificationsService: ToastNotificationsService,
        private navigationService: NavigationService,
    ) {}

    public async verifyPasswordResetToken(data: ValidateTokenData): Promise<void> {
        try {
            await httpClient.POST_UNAUTHENTICATED('password/reset/validate/', data);

            // Ask to use native mobile app if mobile browser detected & app installed
            if (/Mobi|Android/i.test(navigator.userAgent)) {
                window.location.replace(
                    `modernhealth://set-new-password/${data.uidb64}/${data.token}`,
                );
            }
        } catch (error) {
            this.toastNotificationsService.renderErrorToast(
                'Password reset token expired, please request a new one.',
            );

            this.navigationService.navigate('/');
        }
    }
}
